import React from 'react';
import '../css/MacWindow.css';

const MacWindow = ({
  children,
  url = "localhost:3000",
  className = '',
  contentClassName = '',
  toolbarContent = null,
}) => {
  return (
    <div className={`mac-window ${className}`.trim()}>
      <div className="mac-window-header">
        <div className="mac-window-buttons">
          <span className="mac-btn mac-btn-close">
            <svg viewBox="0 0 12 12" width="6" height="6">
              <path d="M1 1l10 10M11 1L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </span>
          <span className="mac-btn mac-btn-minimize">
            <svg viewBox="0 0 12 12" width="6" height="6">
              <path d="M1 6h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </span>
          <span className="mac-btn mac-btn-maximize">
            <svg viewBox="0 0 12 12" width="6" height="6">
              <path d="M2 2h8v8H2z" stroke="currentColor" strokeWidth="1.2" fill="none"/>
            </svg>
          </span>
        </div>
        <div className="mac-window-nav">
          <span className="mac-nav-arrow">‹</span>
          <span className="mac-nav-arrow">›</span>
        </div>
        <div className="mac-window-url-bar">
          <span className="mac-url-icon">🔒</span>
          <span className="mac-url-text">{url}</span>
        </div>
        {toolbarContent && (
          <div className="mac-window-toolbar-slot">
            {toolbarContent}
          </div>
        )}
        <div className="mac-window-actions">
          <span className="mac-action-icon">⟳</span>
          <span className="mac-action-icon">⊕</span>
        </div>
      </div>
      <div className={`mac-window-content ${contentClassName}`.trim()}>
        {children}
      </div>
    </div>
  );
};

export default MacWindow;
